<template>
  <div id="CustomerService" @click="CustomerService()">
    <div class="customer-con">
      <img class="kefu-img" src="http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/kefu.png" alt="">
      <img class="kefu-code" src="http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/kefu_code.jpg" alt="">
    </div>

  </div>
</template>
<script>
export default {
  name: "CustomerService",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    CustomerService() {

    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
#CustomerService {
  width: 70px;
  height: 70px;
  position: fixed;
  right: 20px;
  top: 30%;
  z-index: 99999999;
  cursor: pointer;
}
.kefu-img{
  display: block;
  width: 100%;
  height: auto;
}
.kefu-code {
  position: absolute;
  z-index: 100;
  right: 0;
  top: 80px;
  width: 180%;
  display: none;
  height: auto;
  box-shadow: 1px 1px 5px #ccc;
  transition: 0.5s;
}
.customer-con:hover .kefu-code {
  display: block;
}
@media screen and (max-width: 1000px) {
  #CustomerService {
    width: 50px;
    height: 50px;
  }
  .kefu-code {
    top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue